(function () {
    'use strict';

    angular
        .module('app.plan')
        .factory('DomainsService', domainsService);

    domainsService.$inject = ['$resource'];

    function domainsService($resource) {

        var service = {};
        var domainsResource = $resource('/domains/:action');

        service.getDomains = function (args) {
            var finalArgs;
            if (angular.isUndefined(args)) {
                finalArgs = {
                    action: 'get'
                };
            }
            else {
                finalArgs = {
                    action: 'get',
                    'domain[]': args.domain,
                    'country[]': args.country,
                    'gender[]': args.gender,
                    'age[]': args.age,
                    'education[]': args.education,
                    'employment[]': args.employment,
                    'income[]': args.income,
                    'children[]': args.children,
                    'householdsize[]': args.householdsize
                };
            }

            return domainsResource.get(finalArgs).$promise;
        };

        return service;
    }
})();